import React, { useContext, useState } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'
import AuthContext from 'contexts/AuthContext'
import AuthGuestContext from 'contexts/AuthGuestContext'
import RegulationsContext from 'contexts/RegulationsContext'

const RegulationsProvider = ({ children }) => {
  const [isAccept, setIsAccept] = useState(false)
  const [hasError, setHasError] = useState(false)

  const snackbar = useSnackbar()
  const authContext = useContext(AuthContext)
  const authGuestContext = useContext(AuthGuestContext)
  const location = useLocation()

  const companyId = authContext?.company?.id

  const isGuest = !!authGuestContext

  const isAuthenticated = isGuest
    ? service.guestPortal.auth.isAuthenticated()
    : service.dponet.auth.isAuthenticated()

  const newPasswordMatch = matchPath(location.pathname, {
    path: routes.newPassword,
  })

  const subscriptionMatch = matchPath(location.pathname, {
    path: [routes.subscription.default, routes.subscription.trial],
    exact: true,
  })

  const tokenRaw = newPasswordMatch?.params?.reset_password_token

  const getRegulationVersionsService = () => {
    if (!isAuthenticated) return service.dponet.public.regulationVersions
    if (isGuest) return service.guestPortal.regulationVersions
    return service.dponet.regulationVersions
  }

  const regulationVersionsService = getRegulationVersionsService()

  const canFetch = isAuthenticated || !!tokenRaw || !!subscriptionMatch

  const { response, isLoading, refresh } = useFetch(
    regulationVersionsService.get,
    {
      ...(!isAuthenticated && {
        platform: constants.regulations.PLATFORMS.DPONET,
        ...(subscriptionMatch ? { all: true } : { tokenRaw }),
      }),
    },
    [isAuthenticated, isGuest, tokenRaw, companyId],
    canFetch,
  )

  const regulationVersions = response?.data?.regulationVersions?.filter(
    helpers.regulations.isRegulationVersionValid,
  )

  const acceptRegulation = async (regulationVersionId) => {
    const acceptService = isGuest
      ? service.guestPortal.regulationVersions
      : service.dponet.regulationVersions

    try {
      setIsAccept(true)
      setHasError(false)

      await acceptService.accept(regulationVersionId)
      refresh()
    } catch (error) {
      setHasError(true)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao aceitar o regulamento, caso o problema persista entre em contato com o suporte!',
        variant: 'error',
      })
    } finally {
      setIsAccept(false)
    }
  }

  return (
    <RegulationsContext.Provider
      value={{
        regulationVersions,
        isLoading,
        isAccept,
        hasError,
        acceptRegulation,
        tokenRaw,
      }}
    >
      {children}
    </RegulationsContext.Provider>
  )
}

export default RegulationsProvider
